export enum AptPaymentType {
    Rateizzo = 'Rateizzo',
    UnicaSoluzione = 'Unica Soluzione',
    AccontoSaldo = 'Acconto/Saldo',
    Consumo = 'A Consumo',
    Canone = 'Canone',
}
